export default __webpack_public_path__ + "static/android-icon-192x192-4c0b4545f1551774f6ea8673a8fd21a0.png";